<template>
  <div class="container">
    <div class="policy__message">
      <ZTitle
        class="privacy-policy__title"
        size="medium"
        tag="h1"
      >
        Política de Privacidade
      </ZTitle>

      <ZText
        tag="p"
        align="left"
      >
        Atualizada em 18 de outubro de 2022
      </ZText>

      <ol>
        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Declaração de Privacidade
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            A <strong>QUERO</strong> sabe o quanto é importante conhecer e estar
            seguro sobre a utilização dos dados pessoais que tem em seu poder. Por
            isso, nos preocupamos em esclarecer e explicar a nossa Política de
            Privacidade.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Nós reconhecemos a necessidade de proteção e de gerenciamento adequado das informações
            pessoais coletadas em nosso site, bem como aqueles que nos são compartilhados por nossos
            usuários. A presente Política de Privacidade auxiliará a compreender quais os tipos de
            informações que podemos coletar, como essas informações poderão ser utilizadas, com quem as
            informações poderão ser compartilhadas e quais os direitos dos titulares no que diz respeito
            à proteção de seus dados pessoais.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Quais são as informações pessoais que coletamos
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            As informações pessoais que obtemos podem ser coletadas das seguintes
            formas:
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            <strong>Site:</strong> Informações pessoais são coletadas no momento que o usuário interage em nosso site
            ou aplicativo (Plataforma Quero Pago), por meio de preenchimento de formulários solicitando dados bancários
            e dados pessoais necessários à gestão de pagamentos. Os dados coletados incluem, mas não se limitam, ao
            nome completo, e-mail, além de todo dado pessoal compartilhado de forma espontânea pelo usuário. Ao coletar
            as informações, o usuário escolhe dar, ou não, o consentimento para o tratamento destes dados para envio
            de informações, newsletter, avisos e promoções. É possível se descadastrar da lista de envio de mensagens
            a qualquer momento em nosso portal, ou clicando no link de cancelamento contido no próprio corpo dos
            e-mails. Todas as informações pessoais são colhidas de maneira justa e não invasiva, com o seu
            consentimento voluntário. As informações pessoais não são acessíveis a nenhuma pessoa fora da função
            específica para a qual foram coletadas.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            <strong>Cadastro:</strong> Coletamos os dados de nossos usuários necessários para efetuar o cadastro em
            nosso site ou aplicativo. Os dados são necessários para identificar o usuário e permitir que ele acesse
            produtos e serviços de nossa plataforma, bem como páginas de acesso restrito. Os dados coletados para
            cadastro são: nome completo, e-mail, RG, CPF, foto, data de nascimento, endereço completo e
            telefone. O usuário pode optar por compartilhar estas informações com a QUERO
            através de sua conta do Facebook, Google ou Apple.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            <strong>Canais de atendimento:</strong> O usuário poderá entrar em contato por meio do WhatsApp
            0800 291 7878. Os dados pessoais são coletados com o objetivo de identificar o usuário, bem como
            para atender sua solicitação. Esses dados podem incluir, dentre outros, nome, telefone, CPF e e-mail.
            Além destes, coletamos qualquer dado pessoal que seja informado espontaneamente pelo usuário. É
            estritamente necessário que o usuário realize o consentimento para que o serviço seja prestado.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            <strong>Cookies:</strong> Dados pessoais podem ser coletados por meio
            de cookies. Para mais informações, consulte nossa
            <ZLink
              to="/politica-de-cookies"
              tag="nuxt-link"
              target="_blank"
            >
              Política de Cookies
            </ZLink>.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            <strong>Quero Pago:</strong> Coletamos os dados necessários para que o aluno pague
            suas mensalidades através de nossa plataforma. Os dados necessários incluem nome, CPF,
            telefone, endereço, PIX, conta bancária e cartão de crédito.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            <strong>Geolocalização:</strong> Dados de geolocalização podem ser coletados, caso o
            usuário autorize a coleta a partir do seu dispositivo.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            <strong>Compartilhamento:</strong> Ao concluir o Cadastro, o usuário, por meio do aceite dos Termos de Uso
            da plataforma Quero Pago e da presente Política, estará ciente de que seus dados pessoais poderão ser
            compartilhados com instituições de ensino parceiras para o desenvolvimento do relacionamento e comunicação,
            bem como demais medidas que se façam necessárias para a prestação de serviços educacionais relacionados ao
            objeto social da Quero e/ou entidade de ensino. Podemos, ainda, ter acesso a dados pessoais compartilhados
            pelas instituições de ensino, como comprovantes de matrículas e dados para cobrança das mensalidades.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Mídias Sociais
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            A <strong>QUERO</strong> se utiliza também da mídia social para se comunicar
            e interagir com seus usuários por meio de websites de terceiros como, por exemplo,
            Facebook, Instagram, Youtube, Twitter e LinkedIn. Estes websites de terceiros são uma
            tecnologia baseada na Internet que não é operada ou controlada pela <strong>QUERO</strong>.
            Ao interagir, compartilhar ou “Curtir” a página da <strong>QUERO</strong> no Facebook,
            Instagram, Youtube, Twitter, Linkedin, ou outra mídia social, você poderá revelar determinadas
            informações pessoais a <strong>QUERO</strong> ou a terceiros.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Usamos os “botões sociais” para permitir que os nossos usuários compartilhem ou marquem
            páginas da web. São botões de sites terceiros de mídias sociais, e que podem registrar
            informações sobre suas atividades na internet, incluindo este site. Por favor, reveja os
            respectivos termos de uso e políticas de privacidade dessas plataformas para entender
            exatamente como eles usam suas informações, como optar por não receber ou excluir tais
            informações.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            A quantidade de informações pessoais visíveis dependerá das suas próprias configurações
            de privacidade no Facebook, Instagram, Youtube, Twitter, LinkedIn e demais mídias sociais.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Finalidades e bases legais
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            Relacionamos a seguir as finalidades e bases legais dos tratamentos de dados da <strong>QUERO</strong>:
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            <table class="privacy-policy__table">
              <thead>
                <tr>
                  <th>Fins</th>
                  <th>Base legal</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Cumprir com termos e condições estabelecidos em contrato, inclusive para
                    compartilhamento para as instituições de ensino parceiras.
                  </td>
                  <td>
                    Necessário para execução de contrato no qual o titular de dados pessoais seja parte.
                  </td>
                </tr>
                <tr>
                  <td>
                    Facilitar a comunicação com você (inclusive em casos de emergência e para fornecer a você
                    informações solicitadas).
                  </td>
                  <td>
                    Justifica-se com base em nossos interesses legítimos de assegurar comunicação e gestão de
                    emergências adequadas na organização.
                  </td>
                </tr>
                <tr>
                  <td>
                    Cumprir requisitos legais.
                  </td>
                  <td>
                    Necessário para a conformidade com uma obrigação legal à qual estamos sujeitos.
                  </td>
                </tr>
                <tr>
                  <td>
                    Monitorar o uso que você faz dos nossos sistemas (incluindo monitorar o uso do nosso site e
                    de quaisquer aplicativos e ferramentas que você utilizar).
                  </td>
                  <td>
                    Justifica-se com base nos nossos interesses legítimos de evitar não conformidades e proteger
                    nossa reputação.
                  </td>
                </tr>
                <tr>
                  <td>
                    Escuta social (identificando e analisando o que está sendo dito sobre a <strong>QUERO</strong>
                    nas mídias sociais [somente conteúdo acessível publicamente] a fim de perceber sentimento,
                    intenção, disposição e tendências de mercado, além das necessidades de nossos stakeholders
                    para, dessa forma, melhorar nossos serviços.)
                  </td>
                  <td>
                    Justifica-se com base em nossos legítimos interesses em proteger nossos ativos e nossa
                    marca nas mídias sociais.
                  </td>
                </tr>
                <tr>
                  <td>
                    Melhorar a segurança e o funcionamento do nosso website, aplicativo, redes e informações.
                  </td>
                  <td>
                    Justifica-se com base em nossos legítimos interesses de assegurar que você terá uma experiência
                    de usuário excelente e que nossas redes e informações são seguras.
                  </td>
                </tr>
                <tr>
                  <td>
                    Realizar análises de dados, isto é, aplicar analytics em operações e dados do negócio
                    para descrever, prever e melhorar o desempenho do negócio dentro da <strong>QUERO</strong>
                    e/ou proporcionar uma melhor experiência de usuário. (mais detalhes sobre como usamos analytics
                    em nosso site são encontrados em nossa
                    <ZLink
                      to="/politica-de-cookies"
                      tag="nuxt-link"
                      target="_blank"
                    >
                      Política de Cookies
                    </ZLink>).
                  </td>
                  <td>
                    Justifica-se com base em nossos interesses legítimos de assegurar o funcionamento
                    adequado das nossas operações de negócios.
                  </td>
                </tr>
                <tr>
                  <td>
                    Oferecer nossos produtos e serviços para você (a menos que você tenha mostrado objeção
                    em relação a tal tratamento).
                  </td>
                  <td>
                    Justifica-se com base em nossos legítimos interesses de garantir que podemos conduzir
                    e melhorar nosso negócio
                  </td>
                </tr>
                <tr>
                  <td>
                    Entrega de informações necessárias aos órgãos governamentais
                  </td>
                  <td>
                    Para cumprimento de uma obrigação legal
                  </td>
                </tr>
              </tbody>
            </table>
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Apenas nos baseamos em nosso legítimo interesse para finalidades específicas. Estes tratamentos de dados
            pessoais não se sobrepõem de forma alguma aos interesses, direitos e liberdades dos titulares de dados
            pessoais.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Sobre o compartilhamento e cessão de informações
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            A <strong>QUERO</strong> não tem como prática a divulgação de informações que podem identificar o usuário
            e jamais compartilha informações ou vende e aluga esses dados pessoais a terceiros. Estes dados são de uso
            exclusivo interno da empresa para atingir as finalidades expressas no item anterior.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            Os dados poderão ser compartilhados com terceiros apenas nas seguintes condições:
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            <ul>
              <li>
                Mediante decisão judicial ou solicitação pelos órgãos de fiscalização governamentais;
              </li>
              <li>
                Dados transferidos para órgãos públicos para atender a legislação vigente, por exemplo dados
                pessoais que constem das notas fiscais eletrônicas e respectivos XMLs, ou dados dos nossos
                colaboradores necessários para o pagamento do INSS ou FGTS;
              </li>
              <li>
                Dados transferidos para prestadores de serviço de contabilidade ou recursos humanos,
                para o atendimento de obrigações fiscais e trabalhistas;
              </li>
              <li>
                Dados transferidos para instituições financeiras para viabilizar opções de pagamento aos
                nossos usuários, ou para pagamento de salários aos nossos colaboradores e prestadores;
              </li>
              <li>
                Dados compartilhados com parceiros, operadores e fornecedores de serviços que participam,
                direta ou indiretamente, do desenvolvimento das atividades comerciais da <strong>QUERO</strong>,
                tais como instituições de ensino parceiras, cobranças, processos de pagamento, envio de e-mails,
                propaganda e marketing, segurança e monitoramento de desempenho, serviços de reparos e manutenção,
                processamento e cumprimento de ordens e transações, verificação de informações cadastrais de
                consumidores, pesquisa, guarda de dados, auditoria e processamento de dados;
              </li>
              <li>
                Dados transferidos para fins de execução do contrato, bem como para a proteção dos interesses
                da <strong>QUERO</strong> em qualquer tipo de conflito, incluindo ações judiciais.
              </li>
              <li>
                Dados compartilhados com empresas coligadas, desde que tal compartilhamento seja necessário para
                fins de manutenção ou melhoria na prestação dos serviços aos Usuários, garantido o mesmo nível de
                segurança e o compromisso de atendimento ao disposto na legislação pertinente, conforme indicado na
                presente Política.
              </li>
            </ul>
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Alguns dos prestadores de serviços mencionados acima podem estar localizados no exterior e, nesse caso,
            a QUERO adota salvaguardas adicionais para a garantia de um nível adequado de proteção de dados pessoais,
            de acordo com o disposto na legislação brasileira pertinente.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Segurança da Informação
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            Para assegurar-se de que as suas informações pessoais estão seguras, nós comunicamos as nossas diretrizes
            de privacidade e segurança aos funcionários e parceiros comerciais da <strong>QUERO</strong> e seguimos
            estritamente as medidas de precaução com relação à privacidade dentro da empresa.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Nós nos empenhamos em proteger as suas Informações pessoais, e aquelas confiadas a nós pelos nossos
            usuários, por meio de medidas físicas, técnicas e organizacionais que visem reduzir os riscos de perda,
            mau uso, acesso não autorizado, divulgação e alteração indevida destes dados.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Direitos dos Titulares
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            Os Titulares de dados pessoais têm alguns direitos no que se refere
            aos seus dados pessoais e podem exercê-los entrando em contato conosco
            por meio do e-mail: <ZLink href="mailto:privacidade@quero.com">
              .
              privacidade@quero.com
            </ZLink>.

            <ZText
              tag="p"
              align="left"
            >
              São direitos dos titulares:
            </ZText>

            <ul>
              <li>Confirmação da existência de tratamento de dados pessoais;</li>
              <li>
                Acesso aos dados pessoais, nos termos da legislação aplicável;
              </li>
              <li>
                Correção de dados pessoais incompletos, inexatos ou
                desatualizados;
              </li>
              <li>Portabilidade dos dados pessoais;</li>
              <li>
                Exclusão de dados pessoais, quando este forem tratados com base no
                consentimento do titular ou quando os dados forem desnecessários,
                excessivos ou tratados em desconformidade com a legislação
                aplicável;
              </li>
              <li>
                Solicitação de informações sobre o uso compartilhado de dados
                pessoais;
              </li>
              <li>Revogação do consentimento, quando aplicável.</li>
            </ul>

            <ZText
              tag="p"
              align="left"
            >
              A <strong>QUERO</strong> sempre avaliará a melhor forma de cumprir a solicitação de exercício de algum de
              seus direitos. No entanto, a <strong>QUERO</strong> poderá deixar de atender a sua solicitação, total ou
              parcialmente, em situações específicas resguardadas pela legislação, como, por exemplo, para o
              cumprimento de uma obrigação legal ou um contrato que mantém com você.
            </ZText>

            <ZText
              tag="p"
              align="left"
            >
              Ressaltamos a importância de manter seus dados pessoais precisos e atualizados. Para tanto, mantenha
              a <strong>QUERO</strong> sempre informada se seus dados pessoais mudarem ou estiverem incorretos.
            </ZText>

            <ZText
              tag="p"
              align="left"
            >
              Por motivos de segurança, para as requisições que sejam feitas por meio do e-mail
              <ZLink href="mailto:privacidade@quero.com">
                privacidade@quero.com
              </ZLink>, a solicitação será atendida quando tivermos certeza da identidade do usuário.
              Sendo assim, poderemos solicitar dados ou informações adicionais para a confirmação da
              identidade e da autenticidade do titular. Estes dados e informações serão protegidos durante
              período de armazenamento e eliminados, tão logo esgotada a finalidade de confirmação da
              identidade do titular.
            </ZText>
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Término de Tratamento
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            Esta Política de Privacidade se aplica às circunstâncias acima
            mencionadas durante todo o período em que a
            <strong>QUERO</strong> armazenar os dados pessoais. Nós armazenamos e
            mantemos suas informações: (a) pelo tempo exigido por lei; (b) até o
            término do tratamento de dados pessoais, conforme mencionado abaixo;
            ou (c) pelo tempo necessário a preservar o legítimo interesse da
            <strong>QUERO</strong>. Assim, trataremos seus dados, por exemplo,
            durante os prazos prescricionais aplicáveis ou enquanto necessário
            para cumprimento de obrigação legal ou regulatória.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            O término do tratamento de dados pessoais ocorrerá nos seguintes casos:
            (a) quando a finalidade para qual o dado pessoal foi coletado for alcançada,
            e/ou os dados pessoais coletados deixarem de ser necessários ou pertinentes
            ao alcance de tal finalidade; (b) quando o Titular solicitar a
            exclusão de seus dados; e (c) quando houver uma determinação legal
            neste sentido. Nos casos de término de tratamento de dados pessoais,
            ressalvadas as hipóteses estabelecidas pela legislação aplicável ou
            pela presente Política de Privacidade, os dados pessoais serão
            eliminados.
          </ZText>
          <ZText
            tag="p"
            align="left"
          >
            Nos casos de término de tratamento de dados pessoais,
            ressalvadas as hipóteses estabelecidas pela legislação aplicável ou
            pela presente Política de Privacidade, os dados pessoais serão
            eliminados.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Encarregado de Dados Pessoais (DPO)
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            A <strong>QUERO</strong> disponibiliza abaixo os dados de contato do
            Encarregado de Dados Pessoais (DPO), sendo este o responsável por
            atender toda e qualquer solicitação por parte dos titulares ou da
            Autoridade Nacional, que estejam relacionados com dados pessoais.
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Para qualquer dúvida, solicitação ou reclamação referente ao tratamento de dados pessoais,
            favor entrar em contato com o nosso Encarregado de Dados Pessoais através do e-mail:
            <ZLink href="mailto:privacidade@quero.com">
              privacidade@quero.com
            </ZLink>
          </ZText>

          <ZText
            tag="p"
            align="left"
          >
            Se, apesar do nosso compromisso e esforços para proteger seus dados, você achar que seus
            direitos de proteção de dados não foram atendidos, solicitamos que
            entre em contato com o nosso DPO. Além disso, você tem o direito, a
            qualquer momento, de registrar uma queixa diretamente com a Autoridade
            Nacional de Proteção de Dados, caso entenda que os direitos sobre os
            seus dados pessoais foram infringidos.
          </ZText>
        </li>

        <li class="privacy-policy__list-item">
          <ZTitle
            tag="h2"
            size="nano"
          >
            Mudanças na Política de Privacidade
          </ZTitle>

          <ZText
            tag="p"
            align="left"
          >
            A <strong>QUERO</strong> se reserva no direito de atualizar ou
            modificar esta Política, em qualquer época e sem aviso prévio. No
            entanto, publicaremos sempre a nova versão revisada em nosso website e
            aplicativo. Caso existam alterações na forma em que tratamos dados
            pessoais, você será informado para que verificar se pretende continuar
            utilizando nossos serviços.
          </ZText>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { ZText, ZLink, ZTitle } from '@quero/zilla-vue';

export default {
  components: {
    ZText,
    ZLink,
    ZTitle,
  },
};

</script>

<style lang="scss" scoped>
.policy__message {
  padding: var(--size-jumbo) 0;
  & .ZTitle,
  & .ZText {
    padding: var(--size-small) 0;
  }
}
.privacy-policy__title {
  text-transform: uppercase;
}
.privacy-policy__list-item {
  font-weight: bold;
}
.privacy-policy__inline-block {
  display: inline-block;
}
.privacy-policy__table {
  border-collapse: collapse;
  table-layout: fixed;
}
.privacy-policy__table thead {
  background-color: var(--color-gray-100);
}
.privacy-policy__table th,
.privacy-policy__table td {
  border: var(--size-border-width-small) solid var(--color-gray-300);
  padding: var(--size-small);
  width: 50%;
}
</style>
